module.exports = __webpack_public_path__ + "img/Case_4.d12e8f46.jpg";